import React, { useEffect, useState } from 'react'
import { Alert, Modal, TextInput, FormFieldGroup, ScreenReaderContent, Button, Heading, View } from '@instructure/ui'

const CredentialsModal = ({ open, login, serverUrl, error }) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [url, setUrl] = useState(serverUrl || '')

  useEffect(() => {
    if (open) setUrl(serverUrl || '')
  }, [open, serverUrl])

  const submit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    login(username, password, url)
  }

  return <Modal label='Username and Password' open={open}>
    <Modal.Header><Heading>Login</Heading></Modal.Header>
    <Modal.Body>
      {error ? (
        <View as="div" margin="0 0 small">
          <Alert variant="error" margin="none">
            {error}
          </Alert>
        </View>
      ) : null}
      <form onSubmit={submit}>
        {/* Hidden submit button enables form submission via Enter key press in text inputs */}
        <input type='submit' hidden/>
        <FormFieldGroup description={<ScreenReaderContent>Credentials</ScreenReaderContent>}>
          <TextInput
            renderLabel='Server URL'
            value={url}
            onChange={(_, val) => setUrl(val)}/>
          <TextInput
            autoComplete='username'
            renderLabel='Username'
            value={username}
            onChange={(_, val) => setUsername(val)}/>
          <TextInput
            autoComplete='current-password'
            renderLabel='Password'
            value={password}
            type='password'
            onChange={(_, val) => setPassword(val)}/>
        </FormFieldGroup>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <Button color='primary' onClick={submit}>Login</Button>
    </Modal.Footer>
  </Modal>
}

export default CredentialsModal
